// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2naix","emails":"CreateEditClinics_emails__28KEq","emailTagLabel":"CreateEditClinics_emailTagLabel__vqoVx"};